<script setup>
import { useI18n } from 'vue-i18n';
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import CoursesCarouselCard from '@/components/landing/courses/CoursesCarouselCard.vue';
import resolveImgUrl from '@/services/resolveImageUrl';
import { ref } from 'vue';

const { locale, t } = useI18n();

const lessons = [
  { img: resolveImgUrl('lesson_1.png', locale.value), title: t('landingPage.coursesSection.courses[0].title') },
  { img: resolveImgUrl('lesson_2.png', locale.value), title: t('landingPage.coursesSection.courses[1].title') },
  { img: resolveImgUrl('lesson_3.png', locale.value), title: t('landingPage.coursesSection.courses[2].title') },
  { img: resolveImgUrl('lesson_4.png', locale.value), title: t('landingPage.coursesSection.courses[3].title') },
  { img: resolveImgUrl('lesson_5.png', locale.value), title: t('landingPage.coursesSection.courses[4].title') },
  { img: resolveImgUrl('lesson_6.png', locale.value), title: t('landingPage.coursesSection.courses[5].title') },
  { img: resolveImgUrl('lesson_7.png', locale.value), title: t('landingPage.coursesSection.courses[6].title') },
];
const carousel = ref(null);
const goPrev = () => carousel.value?.prev();
const goNext = () => carousel.value?.next();

</script>

<template>
  <Carousel
    ref="carousel"
    :items-to-show="1"
    :wrap-around="true"
    :transition="500"
    :autoplay="3000"
    :gap="20"
    :breakpoints="{ 768: { itemsToShow: 3 } }"
    class="relative max-w-6xl mx-auto"
  >
    <Slide
        v-for="(lesson, index) in lessons"
        :key="index"
        class="flex justify-center items-center"
    >
      <CoursesCarouselCard
          :img-src="lesson.img"
          :title="lesson.title"
      />
    </Slide>

    <template #addons>
      <button
        @click="goPrev"
        class="absolute top-1/2 -left-12 -translate-y-1/2 z-10 rounded-full"
      >
        <svg
          class="w-8 h-8 text-secondary hover:text-highlight"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 6 10"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 1 1 5l4 4"
          />
        </svg>
      </button>

      <button
        @click="goNext"
        class="absolute top-1/2 -right-12 -translate-y-1/2 z-10 rounded-full"
      >
        <svg
          class="w-8 h-8 text-secondary hover:text-highlight"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 6 10"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 9 4-4-4-4"
          />
        </svg>
      </button>
    </template>
  </Carousel>
</template>
